// =============================================
// MORTGAGE RATES DATA — FinMaple
// Updated weekly (Monday). See bottom for update routine.
// =============================================

export const MORTGAGE_RATES = {
  lastUpdated: "2026-03-06",
  primeRate: 4.45,
  bankOfCanadaRate: 2.25,
  nextBoCDecision: "2026-04-16",
  currency: "CAD",

  // Trend indicators (updated weekly alongside rates)
  trends: {
    fixed5:   { previous: 3.79, trend: "down" },
    variable5: { previous: 3.50, trend: "down" },
    bocRate:  { previous: 2.25, trend: "stable" },
  },

  // =============================================
  // QUEBEC — Best Available Rates (insured/uninsured)
  // Source: nesto.ca, ratehub.ca, bank websites
  // =============================================
  quebec: {
    bestRates: [
      { term: "6 meses fijo",    rate: 2.49, source: "True North" },
      { term: "1 año fijo",      rate: 4.74, source: "True North" },
      { term: "2 años fijo",     rate: 3.74, source: "True North" },
      { term: "3 años fijo",     rate: 3.85, source: "Nesto" },
      { term: "4 años fijo",     rate: 4.47, source: "Nesto" },
      { term: "5 años fijo",     rate: 3.69, source: "Nesto" },
      { term: "5 años variable", rate: 3.45, source: "Nesto" },
      { term: "7 años fijo",     rate: 5.84, source: "Nesto" },
      { term: "10 años fijo",    rate: 7.39, source: "Nesto" },
    ],
  },

  // =============================================
  // CANADA — Best 5-Year Fixed by Lender
  // Source: ratehub.ca, bank websites, nesto.ca
  // =============================================
  canada: {
    fiveYearFixed: [
      { lender: "Big 6 Bank",        rate: 3.79, monthly: 2034, type: "Special" },
      { lender: "CIBC",              rate: 3.79, monthly: 2034, type: "Special" },
      { lender: "Trust Company",     rate: 3.79, monthly: 2034, type: "Special" },
      { lender: "Canwise (Ratehub)", rate: 3.94, monthly: 2066, type: "Special" },
      { lender: "Desjardins",        rate: 4.04, monthly: 2087, type: "Special" },
      { lender: "First National",    rate: 4.14, monthly: 2109, type: "Special" },
      { lender: "MCAP",              rate: 4.24, monthly: 2131, type: "Special" },
      { lender: "RBC",               rate: 4.29, monthly: 2141, type: "Special" },
      { lender: "TD",                rate: 4.29, monthly: 2141, type: "Special" },
      { lender: "Simplii Financial", rate: 4.09, monthly: 2098, type: "Special" },
      { lender: "National Bank",     rate: 4.39, monthly: 2163, type: "Special" },
      { lender: "Tangerine",         rate: 4.49, monthly: 2185, type: "Special" },
      { lender: "BMO",               rate: 4.51, monthly: 2190, type: "Special" },
      { lender: "Scotiabank",        rate: 4.74, monthly: 2240, type: "Special" },
    ],
  },

  // =============================================
  // POSTED RATES by Big 6 Banks (full matrix)
  // Source: bank websites, ratehub.ca
  // =============================================
  postedRates: {
    headers: ["Banco", "Variable 5yr", "Fijo 1yr", "Fijo 2yr", "Fijo 3yr", "Fijo 4yr", "Fijo 5yr", "Fijo 7yr", "Fijo 10yr"],
    banks: [
      { name: "BMO",          variable5: 5.95, fixed1: 7.34, fixed2: 6.99, fixed3: 6.54, fixed4: 6.34, fixed5: 6.49, fixed7: 6.69, fixed10: 7.09 },
      { name: "CIBC",         variable5: 5.95, fixed1: 6.84, fixed2: 6.59, fixed3: 6.99, fixed4: 6.54, fixed5: 6.84, fixed7: 6.65, fixed10: 7.14 },
      { name: "National Bank", variable5: 6.70, fixed1: 7.24, fixed2: 7.84, fixed3: 6.99, fixed4: 6.34, fixed5: 6.39, fixed7: 6.69, fixed10: 7.14 },
      { name: "RBC",          variable5: 5.95, fixed1: 6.09, fixed2: 5.69, fixed3: 4.94, fixed4: 4.89, fixed5: 4.84, fixed7: 5.60, fixed10: 8.00 },
      { name: "Scotiabank",   variable5: 6.90, fixed1: 7.29, fixed2: 6.89, fixed3: 6.54, fixed4: 6.34, fixed5: 6.49, fixed7: 6.70, fixed10: 7.19 },
      { name: "TD",           variable5: 7.15, fixed1: 7.74, fixed2: 7.34, fixed3: 6.94, fixed4: 6.74, fixed5: 6.84, fixed7: 7.10, fixed10: 7.25 },
    ],
  },

  // =============================================
  // SPECIAL OFFER RATES by Big 6 Banks
  // Source: ratehub.ca (only available terms shown)
  // =============================================
  specialRates: {
    headers: ["Banco", "Variable 5yr", "Fijo 1yr", "Fijo 2yr", "Fijo 3yr", "Fijo 4yr", "Fijo 5yr", "Fijo 7yr", "Fijo 10yr"],
    banks: [
      { name: "BMO",          variable5: 5.00, fixed1: null, fixed2: null, fixed3: null, fixed4: 4.44, fixed5: null, fixed7: null, fixed10: null },
      { name: "CIBC",         variable5: 5.95, fixed1: null, fixed2: null, fixed3: 4.34, fixed4: null, fixed5: 5.06, fixed7: null, fixed10: null },
      { name: "National Bank", variable5: 6.45, fixed1: null, fixed2: null, fixed3: 4.79, fixed4: null, fixed5: 4.74, fixed7: null, fixed10: null },
      { name: "RBC",          variable5: 5.85, fixed1: 5.99, fixed2: 5.59, fixed3: 4.84, fixed4: 4.79, fixed5: 4.74, fixed7: 5.50, fixed10: null },
      { name: "Scotiabank",   variable5: null, fixed1: null, fixed2: null, fixed3: null, fixed4: null, fixed5: null, fixed7: null, fixed10: null },
      { name: "TD",           variable5: 6.60, fixed1: null, fixed2: null, fixed3: 4.84, fixed4: null, fixed5: 4.49, fixed7: null, fixed10: null },
    ],
  },

  // =============================================
  // DESJARDINS (Quebec-specific)
  // Source: desjardins.com
  // =============================================
  desjardins: {
    closed: [
      { term: "6 meses",              rate: 7.99 },
      { term: "1 año",                rate: 5.49 },
      { term: "2 años",               rate: 5.59 },
      { term: "3 años",               rate: 5.99 },
      { term: "4 años",               rate: 6.04 },
      { term: "4 años (especial)",    rate: 4.34 },
      { term: "5 años",               rate: 6.09 },
      { term: "5 años (especial)",    rate: 4.39 },
      { term: "6 años",               rate: 6.29 },
      { term: "7 años",               rate: 6.39 },
      { term: "10 años",              rate: 6.89 },
    ],
    open: [
      { term: "6 meses", rate: 9.75 },
      { term: "1 año",   rate: 9.50 },
    ],
  },

  // =============================================
  // NESTO — Quebec Rates (detailed by LTV)
  // Source: nesto.ca
  // =============================================
  nesto: {
    headers: ["Término", "0-65% LTV", "65-70% LTV", "70-75% LTV", "75-80% LTV", "Asegurado", "No asegurado"],
    rates: [
      { term: "2 años fijo",               ltv65: 5.91, ltv70: 6.01, ltv75: 6.11, ltv80: 6.16, insured: 5.91, uninsured: null },
      { term: "3 años fijo",               ltv65: 3.85, ltv70: 3.95, ltv75: 4.05, ltv80: 4.10, insured: 3.85, uninsured: 4.39 },
      { term: "3 años variable",           ltv65: 3.60, ltv70: 3.75, ltv75: 3.80, ltv80: 3.85, insured: 3.60, uninsured: null },
      { term: "4 años fijo",               ltv65: 4.47, ltv70: 4.57, ltv75: 4.67, ltv80: 4.72, insured: 4.47, uninsured: null },
      { term: "5 años fijo",               ltv65: 3.69, ltv70: 3.74, ltv75: 3.89, ltv80: 3.89, insured: 3.64, uninsured: 4.19 },
      { term: "5 años fijo (150 días)",    ltv65: 3.89, ltv70: 3.99, ltv75: 4.09, ltv80: 4.14, insured: 3.89, uninsured: null },
      { term: "5 años variable",           ltv65: 3.45, ltv70: 3.50, ltv75: 3.65, ltv80: 3.65, insured: 3.40, uninsured: 3.85 },
      { term: "5 años variable (150 días)", ltv65: 3.60, ltv70: 3.75, ltv75: 3.80, ltv80: 3.85, insured: 3.60, uninsured: null },
      { term: "7 años fijo",               ltv65: 5.84, ltv70: 5.94, ltv75: 6.04, ltv80: 6.09, insured: 5.84, uninsured: null },
      { term: "10 años fijo",              ltv65: 7.39, ltv70: 7.49, ltv75: 7.59, ltv80: 7.64, insured: 7.39, uninsured: null },
    ],
  },
};

// =============================================
// MARKET CONTEXT (for the intro section)
// =============================================
export const MARKET_CONTEXT = {
  lastUpdated: "2026-03-06",
  summary: {
    es: "En marzo 2026, las tasas hipotecarias en Canadá se estabilizan. El taux directeur del Banco de Canadá está en 2.25% y la tasa preferencial de los bancos es 4.45%. Las tasas fijas a 5 años empiezan desde 3.69% (aseguradas) y las variables desde 3.45%.",
    en: "In March 2026, Canadian mortgage rates are stabilizing. The Bank of Canada rate is at 2.25% and the bank prime rate is 4.45%. 5-year fixed rates start from 3.69% (insured) and variable rates from 3.45%.",
  },
  keyPoints: {
    es: [
      "Tasa directriz Banco de Canadá: 2.25%",
      "Tasa preferencial bancos: 4.45%",
      "Mejor tasa fija 5 años: desde 3.69% (Nesto, asegurada)",
      "Mejor tasa variable 5 años: desde 3.45% (Nesto, asegurada)",
      "Las tasas especiales de los Big 6 empiezan desde 4.34% fijo (CIBC)",
    ],
  },
};

// =============================================
// HOW TO UPDATE (weekly Monday routine)
// =============================================
// 1. Go to ratehub.ca/best-mortgage-rates/5-year/fixed -> update canada.fiveYearFixed
// 2. Go to ratehub.ca -> "Canadian Bank Mortgage Rates" -> update postedRates + specialRates
// 3. Go to nesto.ca/mortgage-rates-in-quebec -> update nesto.rates + quebec.bestRates
// 4. Go to desjardins.com -> taux hypothecaires -> update desjardins
// 5. Go to scotiabank.com -> mortgage rates -> update scotiabank
// 6. Update lastUpdated dates
// 7. Update primeRate and bankOfCanadaRate if changed
// 8. Update MARKET_CONTEXT.summary if anything notable changed
// 9. Commit, push, verify on prod
// Time: ~10 minutes
